var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cts_box"},[_vm._m(0),_c('a',{staticClass:"link_txt",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.logoutClicked}},[_vm._v("複眼経済塾からログアウトする")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"min_ttl"},[_c('span',[_vm._v("複眼経済塾からログアウトする場合はこちら")])])
}]

export { render, staticRenderFns }